<ng-container *ngIf="visible && filter.visible">
   <div [matMenuTriggerFor]="typeMenu">

      <ng-content></ng-content>
      <ng-container *ngIf="filter.v">
         {{names[values.indexOf(filter.v)]?? filter.v}}

      </ng-container>

   </div>

   <mat-menu #typeMenu="matMenu">
      <div class="ctlFilter">
         <mat-radio-group (change)="filter.update($event.value); refresh()" [(ngModel)]="filter.v">
            <div mat-menu-item *ngFor="let v of values; let i=index">

               <mat-radio-button [value]="v">{{names[i]}}</mat-radio-button>


            </div>
         </mat-radio-group>
         <div class="bottom">
            <div class="button" (click)="filter.clear(); refresh()">{{_common.clear}}</div>
         </div>
      </div>
   </mat-menu>
</ng-container>